import i18n from '@/locales';
import { createApp } from 'vue';
import BuildingRentalBrowsing from '@/components/rental/BuildingRentalBrowsing.vue';

const app = createApp({});
app.use(i18n);
app.component('BuildingRentalBrowsing', BuildingRentalBrowsing);
app.mount('#buildingRentalBrowsingApp');